module.exports = __webpack_public_path__ + "img/thumbnail_WestAfricanLion_f_albino.5e75fd1c.png";